module.exports = __webpack_public_path__ + "static/media/mike_costache.5123c568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/mike_costache.jpg
// module id = 1780
// module chunks = 146